<template>
  <a-table
    :columns="columns"
    :data-source="form.rightAttachement"
    rowKey="id"
    :pagination="false"
    tableLayout="fixed"
  >
    <template slot="type" slot-scope="text, record">
      <span class="required-label">
        <span class="required-star" v-if="record.type == '产权情况证明文件'"
          >*</span
        >
        {{ record.type }}
      </span>
    </template>
    <template slot="file" slot-scope="text, record">
      <div class="file-cell-wrapper">
        <a-upload
          action="https://api.jssyjt.net/external-service-center/uploadFile/attachment"
          :headers="uploadHeaders"
          :file-list="record.files"
          @change="(e) => handleAttachmentChange(e, record)"
          :disabled="!isEditable"
          :multiple="true"
          :showUploadList="{ showRemoveIcon: true }"
          :data="{ uploadType: record.uploadType }"
          @download="downloadFile"
          @preview="downloadFile"
        >
          <span
            v-if="!record.files || record.files.length === 0"
          >
            <div v-if="isEditable" class="upload-link"> 请上传附件 </div>
            <div v-else>--</div>
          </span>
        </a-upload>
      </div>
    </template>

    <template slot="status" slot-scope="text, record">
      <span v-if="getUploadedFiles(record).length > 0" class="success">
        已上传（{{ getUploadedFiles(record).length }} 个）
      </span>
      <span v-else class="warning">未上传</span>
    </template>

    <template slot="action" slot-scope="text, record">
      <a-upload
        v-if="isEditable"
        :file-list="record.files"
        action="https://api.jssyjt.net/external-service-center/uploadFile/attachment"
        @change="(e) => handleAttachmentChange(e, record)"
        :headers="uploadHeaders"
        :multiple="true"
        :show-upload-list="false"
        :data="{ uploadType: record.uploadType }"
      >
        <a-button type="default" size="small" class="upload-btn">
          <a-icon type="upload" />
          上传材料
        </a-button>
      </a-upload>
      <template v-else> -- </template>
    </template>
  </a-table>
</template>

<script>
import storage from "store";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    uploadHeaders() {
      const token = storage.get(ACCESS_TOKEN);
      return {
        Authorization: token ? token : "",
      };
    },
  },
  data() {
    return {
      columns: [
        { title: "编号", dataIndex: "id", width: 80 },
        {
          title: "附件类型",
          dataIndex: "type",
          width: 260,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "附件信息",
          dataIndex: "file",
          width: 450,
          scopedSlots: { customRender: "file" },
        },
        {
          title: "状态",
          dataIndex: "status",
          width: 140,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          width: 140,
          scopedSlots: { customRender: "action" },
        },
      ],
      propertyRightsProof: [],
    };
  },
  methods: {
    getUploadedFiles(record) {
      if (!record.files || !record.files.length) return [];
      return record.files.filter((f) => f.status === "done");
    },
    //上传附件
    handleAttachmentChange({ fileList }, record) {
      const newList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });

      // ⭐ 写回当前行
      this.$set(record, "files", newList);
    },
    /**
     * 自定义下载文件 上传文件组件
     * @param {} file 
     */
    downloadFile(file){
      const tmpcnt = file.name.lastIndexOf(".") // 获取.的下标
      const exname = file.name.substring(tmpcnt + 1) // 获取后缀名
      const names = ['pdf', 'txt'];
      if (names.indexOf(exname) < 0) {
        let a = document.createElement('a')
        a.href =file.url
        a.click();
      }
      else{
        window.open(file.url)
      }
      
    },
  },
};
</script>

<style scoped>
.upload-link {
  color: red;
}

.success {
  color: #52c41a;
}

.warning {
  color: #fa8c16;
}
.upload-btn {
  display: inline-flex;
  align-items: center;
}

.upload-btn .anticon {
  font-size: 14px;
  margin-right: 6px;
}

.required-label {
  display: inline-flex;
  align-items: center;
}

.required-star {
  color: #ff4d4f;
  margin-right: 4px;
  font-size: 14px;
  line-height: 1;
}

.file-cell-wrapper /deep/ .ant-upload-list-item-name {
  position: relative;
  top: 3px;
  display: inline-block;
  max-width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>